// General stylesheets are imported here.
// Beware of all SASS code that generates CSS output only ONCE nad here.
import "../styles/index.scss";

import "./aptl-app.scss";
import template from "./aptl-app.hbs";
import { component, query } from "../../../hiyo/decorators.js";
import { Component } from "../../../hiyo/component.js";
import { Http } from "../../../hiyo/http.js";
import { Log } from "../../../hiyo/log.js";
import { Templates } from "../../../hiyo/templates.js";
import { TextInput } from "../text-input/text-input.js";
import { SubmitButton } from "../submit-button/submit-button.js";
import { SystemHelper } from "../../../hiyo/system-helper.js";
import { TicketDialog } from "../ticket-dialog/ticket-dialog.js";
import { Customer } from "./types";
import { DateHelper, LOCALE } from "../../../hiyo/date-helper";


@component(template, true)
export class AptlApp extends Component {

    // Properties
    public pin: string;
    public customer: Customer;
    public stream: MediaStream;
    public settings: MediaTrackSettings;
    public http: Http;

    // Elements
    @query("#video") public video: HTMLVideoElement;
    @query("#submit") public submit: SubmitButton;
    @query("#lpn") public lpn: TextInput;

    public onCreate() {
        Log.i("Welcome to Inpark APTL. The world of fantasy🤡");

        // Register Handlebars templates
        Templates.registerHelpers();

        // Reset PIN
        this.pin = "";

        // Create HTTP client
        this.http = new Http();
    }

    public async onRender() {
        // Login state?
        if (!this.customer) {
        }

        // Logged state?
        if (this.customer) {
            // Enable media stream with rear camera
            try {
                this.stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: {
                            exact: "environment"
                        }
                    },
                    audio: false
                });

                // Assign stream to vide tag
                this.video.srcObject = this.stream;

                // Get settings to have width and height
                this.settings = this.stream.getVideoTracks()[0].getSettings();

                // Set fixed height to respect the ration
                //this.video.height = (this.video.offsetWidth / settings.aspectRatio);

            } catch (e) {
                Log.w(`${this.constructor.name}: No rear camera detected (${e})`);
            }

            // Send plate number
            this.lpn.onSubmit = (value: any): void => {
                // Submit
                this.send();
            }
        }
    }

    public async pinpad(n: string): Promise<void> {
        // Clear?
        if (n == "C") {
            this.pin = "";
        }
        // Submit?
        else if (n == "OK") {
            // Login
            await this.login(this.pin);

            // Clear pin
            this.pin = "";
        }
        // Add number (4 numbers maximum)
        else if (this.pin.length < 4) {
            this.pin += n;
        }

        // Update input only if not logged
        if (!this.customer) {
            this.querySelector("div.pinpad div.number").innerHTML = "꘎".repeat(this.pin.length);
        }
    }

    public async login(pin: string): Promise<void> {
        // Lock self
        this.lock();

        // API call
        try {
            // Store customer
            this.customer = await this.http.request("POST", "https://www.inpark.cloud/api/aptl/auth", {
                data: {
                    pin: Number(this.pin)
                }
            });

            Log.i(`Customer logged in (${this.customer.name})`);

            // Redraw
            this.render();
        }
        catch (e) {
            Log.i(`Error when authorizing ${e}`)
        }

        // Unlock self
        this.unlock();
    }

    public async capture(): Promise<void> {
        // Form data
        let form = new FormData();
        form.append("customerId", String(this.customer.customerId));

        // Get canvas and draw current stream frame to it
        // Before that we set canvas size to video frame resolution
        let canvas = document.querySelector<HTMLCanvasElement>("#canvas");
        canvas.width = this.settings.width;
        canvas.height = this.settings.height;
        canvas.getContext("2d").drawImage(this.video, 0, 0, canvas.width, canvas.height);

        // Convert canvas to blob
        canvas.toBlob(async (blob: Blob): Promise<void> => {
            // Add blob to multipart
            form.append("image", blob);

            // Hide empty message
            this.querySelector("div.video div.empty").classList.add("empty-hidden");

            // Show button loader
            this.submit.lock();
            await SystemHelper.sleep(1000);

            // API call
            let data = await this.http.request("POST", "https://www.inpark.cloud/api/aptl/validation/lpn", {
                form: form
            });

            // Hide button loader
            this.submit.unlock();

            // No plate recognized?
            if (!data.lpn) {
                // Show empty message
                this.querySelector("div.video div.empty").classList.remove("empty-hidden");
            }
            // Plate with ticket
            else {
                // Show ticket
                this.showTicket(data);
            }
        });
    }

    public async send(): Promise<void> {
        // No value?
        if (!this.lpn.options.value?.length) {
            return;
        }

        // Form data
        let form = new FormData();
        form.append("customerId", String(this.customer.customerId));
        form.append("lpn", this.lpn.options.value);

        // API call
        let data = await this.http.request("POST", "https://www.inpark.cloud/api/aptl/validation/lpn", {
            form: form
        });

        // Show ticket
        this.showTicket(data);

        // Clear plate number input
        this.lpn.clear();

    }

    public showTicket(data: any): void {
        // Create dialog
        let dialog = new TicketDialog(this.context, {
            data: data
        });

        // Show
        document.body.appendChild(dialog);
    }
}